<template>
<div class="container assistanceDraw">
  <div :class="noticeShow?'noticeBox showNotice':'noticeBox'">
    <div class="onliCloseBox" @click="showNotice"></div>
    <div class="noticeInfoWarp">
      <div class="noticeInfo">
        <div class="noticeTitle"><img src="https://cms.dafang24.com/aliapp/newYear2021/noticeTitle.png"/></div>
        <div class="txtCont">
          <div class="noticeItem">
            <div class="mianLine">1. 2021年春节订单即日起接受预定。</div>
          </div>
          <div class="noticeItem">
            <div class="mianLine">2. 优惠券使用规则：</div>
            <div class="sItem">
              <div class="sTitle">每满500减60优惠券</div>
              <div>①租期在2021年2月9日-2月17日的春节订单可使用每满即减优惠券；</div>
              <div>②满减初始门槛：每满500元减60元；</div>
              <div>③满减门槛为每满即减形式，上不封顶，如：500减60,1000减120；</div>
            </div>
            <div class="sItem">
              <div class="sTitle">66元无门槛优惠券</div>
              <div>①租期在2021年2月9日-2月17日的订单可使用66元无门槛优惠券；</div>
              <div>②分享3名好友助力成功可得66元无门槛优惠券，可与每满500减60优惠券叠加使用，单笔订单最多叠加使用1张无门槛优惠券；</div>
              <div>③满减门槛为每满即减形式，上不封顶，如：500减60,1000减120；</div>
            </div>
          </div>
          <div class="noticeItem">
            <div class="mianLine">3. 优惠金额为车辆日租金，领券后由系统自动减免，其他费用正常收取；</div>
          </div>
          <div class="noticeItem">
            <div class="mianLine">4. 若发生提前还车或取消订单请见【预订须知】，若需续租或延迟还车需提前24小时联系门店达成协议；</div>
          </div>
          <div class="noticeItem">
            <div class="mianLine">5. 有任何问题，可致电大方租车客服热线：400-666-8818。</div>
          </div>
        </div>
        <div class="noticeBtn">
          <div @click="showNotice">我知道了</div>
        </div>
      </div>
    </div>
  </div>
  <div class="shareWarp" v-if="isShareShow">
    <div class="onliCloseBox" @click="isShareShow=false"></div>
    <div class="cenBox">
      <p class="shareCon" style="word-wrap:break-word;word-break:break-all;white-space:pre-wrap;">快来帮我助力领取优惠券吧！点击链接助我一臂之力<br/>{{ shareUrl }}</p>
      <P class="shareTips">已复制成功，快去粘贴给好友吧</P>
      <p class="closeImg" @click="isShareShow=false">×</p>
    </div>
  </div>
  <div class="contain_wrap">
    <div class="bgWarp">
      <div class="btnimg" @click='gotip'></div>
      <img class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/app.png"/>
      <div class="noticeIconBox" @click="showNotice"></div>
    </div>
    <div class="bgWarp">
      <img class="bgImg" v-if="couponList.length" src="https://cms.dafang24.com/aliapp/newYear2021/z_2.png"/>
      <img class="bgImg" v-else src="https://cms.dafang24.com/aliapp/newYear2021/z_2_1.png"/>
      <div class="buttons getCunponBtn" @click="getCoupon"></div>
    </div>
    <div class="bgWarp"><img class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/z_3.png"/></div>
    <div class="bgWarp">
      <img class="bgImg" v-if="helpNumber<3" src="https://cms.dafang24.com/aliapp/newYear2021/z_4.png"/>
      <img class="bgImg" v-else src="https://cms.dafang24.com/aliapp/newYear2021/z_4_1.png"/>
      <div class="progress">
        <div class="proItem">
          <div class="point"><img v-if="helpNumber>=1" class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/progressIcon.png"/></div>
          <div class="num">1人</div>
        </div>
        <div class="proItem">
          <div class="point"><img v-if="helpNumber>=2" class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/progressIcon.png"/></div>
          <div class="num">2人</div>
        </div>
        <div class="proItem">
          <div class="point"><img v-if="helpNumber>=3" class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/progressIcon.png"/></div>
          <div class="num">3人</div>
        </div>
      </div>
      <div class="buttons shareCunponBtn"><button @click="goShare"></button></div>
    </div>
    <div class="bgWarp"><img class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/z_5.png"/></div>
    <div class="bgWarp">
      <img class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/z_6.png"/>
      <div class="buttons getMoreCar" @click="goRent"></div>
    </div>
    <div class="bgWarp"><img class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/z_7.png"/></div>

    <div class="bgWarp" v-if="false">
      <img class="bgImg" src="https://cms.dafang24.com/aliapp/newYear2021/bg3.png"/>
    </div>
  </div>
</div>
</template>
<script>
import { apiMode, orderSource  } from '@/utils/env';
import { getCurrentMemberInfo, getOfferAssistCount, getConsumerCoupons, drawFitableCoupon } from '@/utils/api';
export default {
  name: 'assistanceDraw',
  data(){
    return{
      couponList: [
        { OfferID: 413, OfferName: "春节-每满即减", Comments: "春节租车--租金每满500元立减60元，租期在2021年2月2日-2月24日的订单可用" }
      ],
      noticeShow: false,
      assistanceID: 415,
      helpNumber: 0,
      myUserID: 0,
      shareUrl: '',
      isShareShow: false,
      name: ''
    }
  },
  created() {
    if( apiMode!='build' ){
      this.couponList[0].OfferID = apiMode=='dev' ? 1329 : 71;
      this.assistanceID = apiMode=='dev' ? 1327 : 74;
    }
  },
  mounted() {
    setTimeout(()=>{
      this.initData();
    }, 500);
  },
  methods:{
    async initData() {
      this.getUserInfo();
    },
    gotip(){
      window.location.href='https://cms.dafang24.com/aliapp/2021/festivalTip.html';
    },
    async getUserInfo () {
      let _host = "http://m.dafang24.com/assistanceShare";
      if( apiMode != 'build' ){
        _host = apiMode=='dev'?'http://localhost:8085/#/assistanceShare':'https://m.sit.dafang24.com/assistanceShare'
      }
      let res = await getCurrentMemberInfo();
      if( res.Code==100 ){
        this.myUserID = res.Data.UserID || 0;
        this.name = res.Data.Name || res.Data.Telephone;
        this.shareUrl = _host + '?userID=' + this.myUserID;
        this.getOfferAssistCountFn();
        this.checkoutOwnerCoupon();
      }
    },
    async getOfferAssistCountFn () {
      let res = await getOfferAssistCount({
        data: {
          offerId: this.assistanceID,
          beAssistUserId: this.myUserID
        }
      });
      if( res.Code==100 ){
        this.helpNumber = res.Data || 0;
      }
    },
    showNotice () {
      this.noticeShow = !this.noticeShow
    },
    async checkoutOwnerCoupon () {
      let _list = this.couponList;
      let res = await getConsumerCoupons();
      if( res.Code==100 ){
        if(res.Data && res.Data.length ){
          for( let i in res.Data ){
            for( let j=0;j<_list.length;j++ ){
              if(res.Data[i].OfferID == _list[j].OfferID ){
                _list.splice(j, 1);
              }
            }
          }
        }
        this.couponList = _list
      }
    },
    async getCoupon() {
      if( this.couponList.length ){
        let getNum = 0, errStr='';
        for( let i in this.couponList ){
          let res = await drawFitableCoupon({
            data: { OfferID: this.couponList[i].OfferID, orgID: 0 }
          });
          if( res.Code==100 ){
            getNum ++;
          } else {
            errStr = res.Message;
          }
        }
        if( getNum>0 ){
          this.flexible.showToast({ content:'领取成功！' });
          this.checkoutOwnerCoupon();
          return;
        }
        this.flexible.showToast({content: errStr });
      } else {
        this.flexible.confirm({
          title: '已经领过券',
          content: '已经领过券了，立即前往租车啦~',
          cancelButtonText: '再看看',
          confirmButtonText: '立即租车',
          success: ()=>{
            this.goRent();
          }
        });
      }
    },
    goRent(){
      if(orderSource==17){
        window.webkit.messageHandlers.goHome.postMessage(null);
      }else if(orderSource==16){
        window.dfpanda.goHome();
      }
    },
    shareLuckDraw () { // 分享
      let _host = "http://m.dafang24.com/assistanceShare";
      if( apiMode != 'build' ){
        _host = apiMode=='dev'?'http://192.168.3.29:8085/#/assistanceShare':'https://m.sit.dafang24.com/assistanceShare'
      }
      let _content = JSON.stringify({
        title: (this.name || '大方租车') + '邀您助力啦~',
        summary: '春节租车优惠不封顶，请助我一臂之力吧！点击一下，立即助力',
        picApp: 'https://cms.dafang24.com/aliapp/newYear2021/microShareIcon.png',
        picH5: 'https://cms.dafang24.com/aliapp/newYear2021/appSharIcon.png',
        path: `/pages/rent/assistanceShare/assistanceShare?userID=${this.myUserID}`,
        url: `${_host}?userID=${this.myUserID}`
      });
      if( orderSource==17 ){
        window.webkit.messageHandlers.doShare.postMessage(_content);
      } else if ( orderSource==16 ){
        dfpanda.doShare(_content);
      }
    },
    goShare() {
      if( this.helpNumber>3 ){
        this.flexible.confirm({
          title: '已领券',
          content: '已经领到券了，立即前往租车啦~',
          cancelButtonText: '再看看',
          confirmButtonText: '立即租车',
          success: ()=>{
            this.goRent();
          }
        });
        return;
      }
      this.shareLuckDraw();
    }
  }
}
</script>
<style scoped type="text/css" lang="scss">
body {
  background-color: #FFF9E4;
}
.header {
  width: 100%;
}
.header img {
  width: 100%;
  height: 687px;
}
.shareWarp {
  position: fixed;
  top: 0; left: 0;
  z-index: 3;
  width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.7);
  transition: .2s;
  .cenBox {
    width: 636px; height: 642px;
    position: absolute;
    top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: url("https://cms.dafang24.com/aliapp/newYear2021/shareAlert.png") no-repeat left top;
    background-size: cover;
    img { width: 100%; }
    .shareCon {
      width: 61.4%; margin: 90px auto 0;
      text-align: center;
      font-size: 30px; color: #E74D4E;
      font-weight: bold; line-height: 48px;
    }
    .shareTips {
      text-align: center; width: 100%;
      color: #fff; font-size: 26px;
      position: absolute;
      top: 500px;
    }
    .closeImg {
      color: #CCCCCC; font-weight: 100;width: 100%;
      font-size: 88px; text-align: center;
      position: absolute; top: 670px;
    }
  }
}

.noticeIconBox {
  position: absolute;
  top: 260px;
  right: 0;
  z-index: 2;
  width: 60px;
  height: 160px;
}
.noticeBox {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 0;
  background-color: rgba(0,0,0,0.7);
  transition: .5s;
  z-index: 3;
  overflow: hidden;
}
.showNotice { height: 100%; }
.onliCloseBox {
  position: absolute;
  left: 0; top: 0;
  width: 100%;
  height: 100%;
}
.noticeBox .noticeInfoWarp {
  position: absolute;
  left: 0; bottom: 0;
  width: 100%;
  padding-top: 52px;
  height: 1080px;
  z-index: 2;
}
.noticeBox .noticeInfo {
  position: relative;
  background-color: #FFF9EC;
  border-radius: 20px 20px 0 0;
  padding-top: 80px;
}
.noticeBox .txtCont {
  width: 100%;
  height: 850px;
  overflow-y: auto;
}
.noticeTitle {
  width: 100%;
  text-align: center;
  position: absolute;
  top: -51px;
}
.noticeTitle img {
  width: 434px;
}
.noticeItem {
  color: #1c1c1c;
  padding: 0 50px;
  line-height: 45px;
  font-size: 26px;
}
.sItem {
  padding-left: 28px;
}
.sItem .sTitle {
  width: 290px;
  height: 44px;
  color: #FDE9CD;
  text-align: center;
  line-height: 44px;
  border-radius: 10px;
  background-color: #E6514D;
  font-weight: bold;
}
.noticeBtn {
  margin: 26px auto 0;
  padding-bottom: 60px;
}
.noticeBtn div {
  width: 654px;
  height: 90px;
  background-color: #F85567;
  border-radius: 16px;
  margin: 0 auto;
  text-align: center;
  line-height: 90px;
  color: #FDE9CD;
  font-size: 30px;
}
.bgWarp {
  width: 100%;
  position: relative;
}
.bgWarp .bgImg {
  width: 100%;
  vertical-align: top;
}
.bgWarp .progress {
  display: flex;
  width: 360px;
  height: 4px;
  background-color: #fff;
  justify-content: space-between;
  position: absolute;
  left: 195px; top: 590px;
  z-index: 2;
}
.bgWarp .progress .proItem {
  width: 32px;
}
.bgWarp .progress .point {
  width: 32px;
  height: 32px;
  background-color: #fff;
  border-radius: 50%;
  /* overflow: hidden; */
  position: relative;
  top: -14px;
}
.bgWarp .progress img {
  width: 100%;
}
.bgWarp .progress .num {
  width: 40px;
  color: #fff;
  text-align: center;
  font-size: 22px;
}
.bgWarp .buttons {
  position: absolute;
  left: 100px; bottom: 20px;
  width: 550px;
  height: 180px;
  /*background-color: rgba(0,0,0,0.5);*/
  opacity: 0;
  z-index: 2;
}
.bgWarp .getMoreCar {
  width: 690px;
  left: 30px;  bottom: 0;
}
.bgWarp .buttons button {
  width: 100%;
  height: 100%;
}
.btnimg{
  width:100%;
  height:160px;
  position: absolute;
  top:780px;
}
</style>


